<div class="eula-dialog">
  <div class="eula-dialog__header">
    <h2 mat-dialog-title class="eula-dialog__title">{{ title }}</h2>
  </div>

  <mat-dialog-content class="eula-dialog__content" #eulaContent>
    <div class="eula-dialog__eula-document">
      <div [innerHTML]="sanitizedContent"></div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="eula-dialog__actions">
    <div>
      <button
        mat-raised-button
        class="eula-dialog__accept-btn"
        [class.eula-dialog__accept-btn--disabled]="!isAcceptButtonEnabled"
        [disabled]="!isAcceptButtonEnabled"
        (click)="onAccept()"
        [attr.title]="!hasReadFullDocument ? 'Please read the complete document first' : ''"
      >
        {{ isSavingEula ? 'Processing...' : 'Accept' }}
      </button>
    </div>
  </mat-dialog-actions>
</div>
